import React, { useState } from "react";
import { stack as Menu } from "react-burger-menu";
import "./Sidebar.css";
import { Link } from "react-scroll";
import { BsMoonFill } from "react-icons/bs";
import { HiOutlineSun } from "react-icons/hi";
import { useTranslation } from "react-i18next";
export default (props) => {
  const [darkMode, setDarkMode] = useState(false);
  React.useEffect(() => {
    const json = localStorage.getItem("site-dark-mode");
    const currentMode = JSON.parse(json);
    if (currentMode) {
      setDarkMode(true);
    } else {
      setDarkMode(false);
    }
  }, []);

  React.useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
    const json = JSON.stringify(darkMode);
    localStorage.setItem("site-dark-mode", json);
  }, [darkMode]);
  const [language, setLanguage] = useState("en");
  const { t, i18n } = useTranslation();
  return (
    <Menu width={400}>
      <div className="buttons btnSlidebar">
        <button
          className="button darkModeBtn "
          onClick={() => {
            if (language === "en") {
              i18n.changeLanguage("fr");
              setLanguage("fr");
            } else {
              i18n.changeLanguage("en");
              setLanguage("en");
            }
          }}
        >
          <span className="lang">{language.toUpperCase()}</span>
        </button>
        <button
          className="button darkModeBtn "
          onClick={() => setDarkMode(!darkMode)}
        >
          {darkMode ? (
            <BsMoonFill size={20} color={"hsl(142, 52%, 96%)"} />
          ) : (
            <HiOutlineSun size={20} color={"#0A80B3"} />
          )}
        </button>
      </div>
      <Link activeClass="active" smooth spy to="home" className="menu-item">
        {t("tr.home")}
      </Link>
      <Link activeClass="active" smooth spy to="about" className="menu-item">
        {t("tr.about")}
      </Link>

      <Link activeClass="active" smooth spy to="skills" className="menu-item">
        {t("tr.skills")}
      </Link>
      <Link activeClass="active" smooth spy to="projects" className="menu-item">
        {t("tr.projects")}
      </Link>
      <Link activeClass="active" smooth spy to="contact" className="menu-item">
        Contact
      </Link>
    </Menu>
  );
};
